module.exports = __webpack_public_path__ + "./images/141431253a1f870f55c3d02e9f09c7d7.webp";